/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as GroupDefs from './defs.defs.js'

const $nsid = 'chat.bsky.group.getJoinLinkPreviews'

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  codes: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string(), {
    minLength: 1,
    maxLength: 50,
  }),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  joinLinkPreviews: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<GroupDefs.JoinLinkPreviewView>(
      (() => GroupDefs.joinLinkPreviewView) as any,
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** [NOTE: This is under active development and should be considered unstable while this note is here]. Get public information about groups from join links. Invalid or disabled codes are silently omitted from results. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

export const $lxm = $nsid
